





















































import { Component, Vue } from "vue-property-decorator";
import TermsAndConditionsLink from "@app/shared/components/termsAndConditions/termsAndConditionsLink.vue";
import * as _ from "lodash";
import * as ApplicationStore from "@src/store/applicationStore";
import { OrganisationController } from "@proxy/OrganisationController";

@Component({
    components: {
        TermsAndConditionsLink
    }
})

export default class AdditionalInfo extends Vue {
    private contactDetails = Array<ProxyModel.ContactDetailViewModel>();

    mounted() {
        this.getContactDetails();
    }

    private getContactDetails() {
        new OrganisationController().getContactDetails().then(response => {
            this.contactDetails = response.successData;
        });
    }

    get isOfba(): boolean {
        return ApplicationStore.isOfba(this.$store);
    }
}
